import { nanoid } from 'nanoid';
import React, { useRef } from 'react';

import Input from 'components/digifi-wrappers/TextInput';
import { TextInputPropsSingleLine } from 'product_modules/components/TextInput';

export type TextInputProps = Omit<TextInputPropsSingleLine, 'onChange' | 'ref' | 'name' | 'id'> & {
  formatter?: (value: string) => string;
  onChange: (value: string) => void;
};

const TextInput = ({ formatter, onChange, ...props }: TextInputProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = formatter ? formatter(event.target.value) : event.target.value;
    onChange(value);
  };

  //Unique autoComplete value to prevent browser from autofilling the field
  const uniqueId = useRef(nanoid());

  return (
    <Input
      name={uniqueId.current}
      autoComplete={uniqueId.current}
      id={uniqueId.current}
      onChange={handleChange}
      {...props}
    />
  );
};

export default TextInput;
